<template>
  <div class="video-testimonials__wrapper" ref="wrapper">
    <div class="video-testimonials__header-wrapper" ref="header">
      <slot name="header"></slot>
    </div>
    <div class="video-testimonials__slider-wrapper" ref="slider">
      <slot name="slider"></slot>
    </div>
    
    
  </div>
  <!-- Custom Video Lightbox -->
  <div 
      class="video-lightbox" 
      ref="lightbox"
      v-if="isVideoVisible"
      @click.self="hideVideo"
    >
      <div class="video-lightbox__content">
        <button class="video-lightbox__close" @click="hideVideo">
          <span class="icon icon-close"></span>
        </button>
        <div class="video-lightbox__video">
          <iframe 
            v-if="currentVideoUrl"
            :src="currentVideoUrl + '?autoplay=1'"
            frameborder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
</template>

<script>
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'VideoTestimonialsSlider',
  
  data() {
    return {
      scrollTrigger: null,
      isVideoVisible: false,
      currentVideoUrl: null
    }
  },
  
  mounted() {
    this.$nextTick(() => {
      this.initScroll()
      this.initVideoClicks()
      window.addEventListener('resize', this.handleResize)
    })
  },
  
  beforeDestroy() {
    if (this.scrollTrigger) {
      this.scrollTrigger.kill()
    }
    window.removeEventListener('resize', this.handleResize)
  },
  
  watch: {
    isVideoVisible(newValue) {
      if (newValue) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    }
  },
  
  methods: {
    initScroll() {
      const slider = this.$refs.slider
      const videosWrap = slider.querySelector('.videos-wrap')
      if (!videosWrap) return
      
      const slides = slider.querySelectorAll('.video-testimonials__item')
      if (slides.length === 0) return
      
      const firstSlide = slides[0]
      const lastSlide = slides[slides.length - 1]
      
      const containerWidth = slider.offsetWidth
      
      // Start position: First slide centered
      const startX = (containerWidth - firstSlide.offsetWidth) / 2
      
      // End position: Last slide centered - need to calculate where slider should be for this
      const totalContentWidth = videosWrap.scrollWidth
      
      // The distance from left of content to center of last slide
      const lastSlideCenterOffset = totalContentWidth - (lastSlide.offsetWidth / 2)
      
      // To center last slide, we need container center to align with last slide center
      // So we position the slider to have the last slide center at container center
      const endX = -(lastSlideCenterOffset - containerWidth / 2)
      
      // Total scroll distance
      const totalScroll = startX - endX
      
      // Set initial position
      gsap.set(slider, { x: startX })
      
      // console.log({
      //   containerWidth,
      //   totalContentWidth,
      //   lastSlideWidth: lastSlide.offsetWidth,
      //   startX,
      //   endX,
      //   totalScroll
      // })
      
      this.scrollTrigger = ScrollTrigger.create({
        trigger: this.$refs.wrapper,
        start: "center center",
        end: `+=${totalScroll + 100}`,
        pin: true,
        pinSpacing: true,
        anticipatePin: 1,
        invalidateOnRefresh: true,
        onUpdate: (self) => {
          // Linear interpolation between start and end positions
          const x = startX - (self.progress * totalScroll)
          gsap.set(slider, { x })
        },
      })
    },

    handleResize() {
      if (this.scrollTrigger) {
        this.scrollTrigger.kill()
        this.initScroll()
      }
    },
    
    initVideoClicks() {
      const videoItems = this.$refs.wrapper.querySelectorAll('.video-testimonials__item')
      videoItems.forEach(item => {
        item.addEventListener('click', () => {
          const videoUrl = item.dataset.video
          if (videoUrl) {
            this.showVideo(videoUrl)
          }
        })
      })
    },
    
    showVideo(url) {
      const videoId = this.getYouTubeId(url)
      if (videoId) {
        this.currentVideoUrl = `https://www.youtube.com/embed/${videoId}`
        this.isVideoVisible = true
      }
    },
    
    hideVideo() {
      this.isVideoVisible = false
      this.currentVideoUrl = null
    },
    
    getYouTubeId(url) {
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/
      const match = url.match(regExp)
      return (match && match[2].length === 11) ? match[2] : null
    }
  }
}
</script>

